<template>
    <div v-if="utente" class="card sa-siat-card-pratica shadow-sm">
        <div class="sa-siat-card-header-custom">
            <b-row>
                <b-col cols="12" md="4">
                    <div class="sa-siat-label-pai">Codice Fiscale</div>
                    <div class="h5 mb-0 text-primary">{{ utente.codiceFiscaleOperatore }}</div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="sa-siat-label-pai">Nominativo</div>
                    <div>{{ utente.cognome }} {{ utente.nome }}</div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="sa-siat-label-pai">Stato</div>
                    <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-' + (utente.stato === 'ATTIVO' ? 'aperta' : 'da-programmare')">{{ utente.stato }}</span>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col cols="12" md="4">
                    <div class="sa-siat-label-pai">Ruolo</div>
                    <span class="badge badge-outline-primary border border-primary text-primary px-2">{{ utente.tipoOperatoreDisplay }} ({{ utente.tipoOperatoreCode }})</span>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="sa-siat-label-pai">Contatti</div>
                    <div>{{ utente.telefono || "-" }} / {{ utente.email || "-" }}</div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="sa-siat-label-pai">Sesso / Data di Nascita</div>
                    <div>{{ utente.gender === "male" ? "Maschio" : utente.gender === "female" ? "Femmina" : "-" }} / {{ utente.birthDate ? formatDate(utente.birthDate) : "-" }}</div>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col cols="12" md="4">
                    <div class="sa-siat-label-pai">Periodo</div>
                    <div>{{ formatDate(utente.dataInizio) }} - {{ utente.dataFine ? formatDate(utente.dataFine) : "in corso" }}</div>
                </b-col>
                <b-col cols="12" md="8" class="text-right">
                    <router-link :to="'/andiamo/utenti/' + utente.codiceFiscaleOperatore" class="btn btn-outline-secondary">
                        <i class="fas fa-edit"></i>
                        Modifica
                    </router-link>
                    <b-button v-if="utente.stato === 'ATTIVO'" variant="outline-danger" class="ml-1" @click="$emit('disattiva', utente)">
                        <i class="fas fa-user-slash"></i>
                        Disattiva
                    </b-button>
                    <b-button v-else variant="outline-success" class="ml-1" @click="$emit('riattiva', utente)">
                        <i class="fas fa-user-check"></i>
                        Riattiva
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>
    <no-data-component v-else title="Utente non trovato in locale: sincronizzalo da AnDIamo" :fontSize="15" :paddingSize="0.5" />
</template>

<script>
import AndiamoMixin from "../mixins/AndiamoMixin";
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";

export default {
    components: { NoDataComponent },
    mixins: [AndiamoMixin],
    data() {
        return {
            codiceFiscaleOperatore: null,
            utente: null,
        };
    },
    mounted() {
        this.codiceFiscaleOperatore = this.$route.params.codiceFiscaleOperatore;
        this.loadData();
    },
    methods: {
        loadData() {
            this.andiamoCaricaDettaglioUtenteLocale(this.codiceFiscaleOperatore, this.onLoadSuccess);
        },
        onLoadSuccess(response) {
            this.closeShowModalLoading();
            let lista = response.data.data.list || [];
            this.utente = lista.length ? lista[0] : null;
        },
    },
};
</script>

<style scoped>
.sa-siat-card-pratica {
    border: none;
    border-radius: 12px;
    overflow: hidden;
}
.sa-siat-card-header-custom {
    background: #fff;
    padding: 15px 20px;
}
.sa-siat-label-pai {
    font-weight: bold;
    color: #7f8c8d;
    text-transform: uppercase;
    font-size: 0.85rem;
}
.sa-siat-badge {
    display: inline-block;
    font-size: 0.9rem;
}
.sa-siat-badge-aperta {
    color: #07af07;
}
.sa-siat-badge-da-programmare {
    color: #e67e22;
}
</style>
